export default () => import(/* webpackChunkName: 'coffee/activities/membership/rights-detail' */ './RightsDetail');
